
import * as vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dropdownOpen: false,
    };
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    getSelectedText() {
      if (!this.vModel || this.vModel.length === 0) return "";
      if (this.vModel.length === 1) {
        const option = this.options.find((opt) => opt.key === this.vModel[0]);
        return option ? option.name : this.vModel[0];
      }
      return `${this.vModel.length} items selected`;
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    isSelected(value) {
      return this.vModel && this.vModel.includes(value);
    },
  },
};
